import { getRoutesFormData, getRoutesKey } from "~/helpers/search"

export default function useSearchRelated(routes, options = {}) {
    const routesKey = getRoutesKey(routes)

    return ReactQuery.useQuery({
        queryKey: ['search', 'related', routesKey],
        queryFn: ({ signal }) => searchAction.fetchSearchRelatedData({ routes: getRoutesFormData(routes), signal })
            .then(response => ({
                hotels: response.hotels || [],
                main_events: response.main_events || [],
                events: response.events || [],
                barometer: response.barometer || { items: [] },
            })),
        staleTime: Infinity,
        gcTime: Infinity,
        enabled: 'enabled' in options ? options.enabled : true,
    })

}
